import { NavigationStyleResponse } from 'api/navigationStyle'
import { initialState as styleInitialState } from 'slices/Cms/Content/AppNavigation/Style/initialState'
import { StyleSettings } from 'slices/Cms/Content/AppNavigation/Style/types'

/**
 * Transforms API response data to slice state format for resetting style state
 * @param navigationStyleData - The API response containing navigation style settings
 * @returns StyleSettings object that can be passed to resetStyleState action
 */
export const apiStateToSliceState = (
  navigationStyleData: NavigationStyleResponse
): StyleSettings => {
  if (!navigationStyleData?.settings) {
    return styleInitialState.settings
  }

  const settings = navigationStyleData.settings
  return {
    placement:
      settings.navigation_placement || styleInitialState.settings.placement,
    backgroundColor:
      settings.navigation_tab_bg_color ||
      styleInitialState.settings.backgroundColor,
    defaultLabelColor:
      settings.navigation_tab_label_default_color ||
      styleInitialState.settings.defaultLabelColor,
    selectedLabelColor:
      settings.navigation_tab_label_selected_color ||
      styleInitialState.settings.selectedLabelColor,
  }
}

/**
 * Transforms slice state to API payload format for updating navigation style
 * @param appId - The application ID
 * @param themeId - The theme ID
 * @param styleSettings - The current style settings from the slice
 * @returns API payload object for updateNavigationStyle mutation
 */
export const sliceStateToApiState = (
  appId: number,
  themeId: number,
  styleSettings: StyleSettings
) => {
  return {
    appId,
    themeId,
    navigation_tabs: {
      navigation_tab_bg_color: styleSettings.backgroundColor,
      navigation_tab_label_selected_color: styleSettings.selectedLabelColor,
      navigation_tab_label_default_color: styleSettings.defaultLabelColor,
      navigation_placement: styleSettings.placement,
    },
  }
}
